import { FormikHelpers } from "formik";
import { showErrorToastMsg } from "../../../generic-components/messages/CvpToastMessages";
import { translateErrorMessageFromBackend } from "../../../localization/translateErrorMessageFromBackend";

let id = 0;
export const handleFormSubmitError = (err, helpers: FormikHelpers<any>) => {
  console.error(err);

  const withCorrelationId = getFormSubmitErrorMessage(err);

  showErrorToastMsg(withCorrelationId);

  helpers.setErrors({ [`error${++id}`]: withCorrelationId });
};

export function getFormSubmitErrorMessage(err) {
  const text = err?.response?.data ?? err?.message ?? err;
  const correlationId = err?.cvpBffCorrelationId;
  const translated = translateErrorMessageFromBackend(text);

  const withCorrelationId =
    translated + (correlationId ? ` (${correlationId})` : "");

  return withCorrelationId;
}
